document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('buy-guide-form');
  const wizard = document.querySelector('.buy-guide__wizard');
  const content = document.querySelector('.buy-guide__content');
  const prevButton = document.getElementById('prev-step');
  const nextButton = document.getElementById('next-step');
  const submitButton = document.getElementById('submit-guide');
  const buttonWrapper = document.querySelector('.buy-guide__navigation');
  const loadingOverlay = document.querySelector('.buy-guide .loading-overlay__spinner');

  // Store the navigation history
  let history = [];
  let currentQuestion = null;

  let answersData = {
    questionnaire: [],
  };
  let filterParameters = {};


  // Function to show message
  function showMessage(message, type, timeout, elementId = 'form-message') {
    const messageElement = document.getElementById(elementId);
    messageElement.textContent = message;
    messageElement.className = `buy-guide__form-message buy-guide__form-message--${type}`;
    messageElement.style.display = 'block';

    // Hide message after 5 seconds
    if (timeout) {
      setTimeout(() => {
        messageElement.style.display = 'none';
      }, timeout);
    }
  }

  // Always attach the submit handler before any mode logic
  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    try {
      // Transform answersData.questionnaire into a flat object for Zapier
      const flatData = {};
      answersData.questionnaire.forEach(q => {
        // For radio questions, use data-answer if available
        if (q.type === 'radio') {
          // Find the input element for this answer
          const questionEl = Array.from(document.querySelectorAll('.buy-guide__question')).find(el => {
            const text = el.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
            return text === q.question;
          });
          let dataAnswer = q.answer;
          if (questionEl) {
            const input = questionEl.querySelector(`input[type="radio"][value="${q.answer.replace(/"/g, '\"')}"]`);
            if (input && input.hasAttribute('data-answer')) {
              dataAnswer = input.getAttribute('data-answer');
            }
          }
          flatData[q.question] = dataAnswer;
        } else if (q.type === 'size') {
          // For size, send both checked checkboxes and the input value
          const questionEl = Array.from(document.querySelectorAll('.buy-guide__question')).find(el => {
            const text = el.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
            return text === q.question;
          });
          let inputValue = '';
          if (questionEl) {
            const input = questionEl.querySelector('.size-input');
            if (input) inputValue = input.value;
          }
          flatData[q.question] = {
            checkboxes: q.answer,
            input: inputValue
          };
        } else {
          flatData[q.question] = q.answer;
        }
      });

      // Add marketing consent value
      const marketingConsent = document.getElementById('marketing-consent');
      flatData['marketing_consent'] = marketingConsent && marketingConsent.checked ? 'yes' : 'no';

      // Build the URL with filter parameters
      const baseUrl = window.buyGuideSettings.collectionToFilter;
      const urlParams = Object.entries(filterParameters)
        .filter(([key, value]) => isNonEmptyStringOrArray(value))
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return value
              .filter(v => typeof v === 'string' && v.trim() !== '')
              .map((v) => `${key}=${encodeURIComponent(v)}`)
              .join('&');
          }
          return `${key}=${encodeURIComponent(value)}`;
        })
        .filter(Boolean)
        .join('&');

      // Add the built filter URL to the data sent to Zapier
      const filterUrlForZapier = urlParams ? `https://loop-sports.fr${baseUrl}?${urlParams}` : `https://loop-sports.fr${baseUrl}`;
      flatData['filter_url'] = filterUrlForZapier;

      await sendToZapier(flatData);

      // Redirect to collection page with filters
      const redirectUrl = urlParams ? `${baseUrl}?${urlParams}` : baseUrl;

      // Only redirect if not in show-all-questions mode
      if (window.buyGuideSettings.redirectToCollection == 'true' && !showAllQuestionsUser) {
        window.location.href = redirectUrl;
      } else if (showAllQuestionsUser) {
        // In show-all-questions mode, only show the success or error message (handled by sendToZapier)
        // Do nothing else
        return;
      } else {
        const productGridContainer = document.getElementById('product-grid');
        const filterUrl = document.getElementById('filter-url');
        const filterUrlLink = filterUrl.querySelector('a');
        const buyGuideForm = document.getElementById('buy-guide-form');
        const loadingOverlay = document.querySelector('.buy-guide .loading-overlay__spinner');
        
        
        loadingOverlay.style.display = 'block';
        // Show and update the debug URL


        if (productGridContainer) {

          // Build the URL with the section parameter
          const sectionUrl = `${baseUrl}?sections=main-collection-product-grid&${urlParams}`;

          // Fetch the section content
          fetch(sectionUrl)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              console.log('Received data:', data);
              // Extract just the product grid div from the response
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = data['main-collection-product-grid'];
              const productGrid = tempDiv.querySelector('#product-grid');
              const titleWrapper = tempDiv.querySelector('.title-wrapper');

              if (productGrid) {
                loadingOverlay.style.display = 'none';
                productGridContainer.innerHTML = productGrid.innerHTML;
                buyGuideForm.style.display = 'none';
                
                // Update title wrapper if it exists
                if (titleWrapper) {
                  document.querySelector('.buy-guide__product-grid-message').style.display = 'none';
                  const existingTitleWrapper = document.querySelector('.title-wrapper');
                  if (existingTitleWrapper) {
                    const titleElement = existingTitleWrapper.querySelector('.title');
                    if (titleElement) {
                      titleElement.textContent = window.buyGuideSettings.titleNoResults;
                      
                      // Create and insert description paragraph after the title
                      const descriptionElement = document.createElement('p');
                      descriptionElement.innerHTML = window.buyGuideSettings.titleNoResultsDescription;
                      titleElement.after(descriptionElement);

                      
                    }
                  }
                } 
                showMessage(window.buyGuideSettings.showProductGridMessage, 'info', null, 'form-message-show-product-grid');
                
              } else {
                showMessage(window.buyGuideSettings.errorMessage, 'error', 5000);
                console.error('Product grid not found in response');
              }
            })
            .catch((error) => {
              console.error('Error fetching product grid:', error);
              showMessage('Une erreur est survenue lors du chargement des produits.', 'error', 5000);
            });
        } else {
          showMessage('Une erreur est survenue lors du chargement des produits.', 'error', 5000);
        }
      }
    } catch (error) {
      console.error('Error in form submission:', error);
      showMessage(
        'Une erreur est survenue lors de la soumission de votre sélection. Veuillez réessayer.',
        'error',
        5000
      );
    }
  });

  // Check if we are in 'show all questions' mode (immediately before wizard init)
  const showAllQuestionsUser = wizard.classList.contains('buy-guide--show-all-questions-user');

  if (showAllQuestionsUser) {
    loadingOverlay.style.display = 'none';
    console.log('[Buy Guide] Show all questions mode active');
    // Show all questions
    const questions = content.querySelectorAll('.buy-guide__question');
    questions.forEach((question) => {
      if (question.dataset.question === 'Catégorie') {
        question.style.display = 'grid';
      } else {
        question.style.display = 'block';
      }
      // Also show all nested questions
      const nestedQuestions = question.querySelectorAll('.buy-guide__question');
      nestedQuestions.forEach((nested) => {
        if (nested.dataset.question === 'Catégorie') {
          nested.style.display = 'grid';
        } else {
          nested.style.display = 'block';
        }
      });
    });
    // Always show navigation buttons and wizard navigation in show-all-questions mode
    if (buttonWrapper) buttonWrapper.style.display = 'flex';
    if (prevButton) prevButton.style.display = 'none';
    if (nextButton) nextButton.style.display = 'none';
    if (submitButton) submitButton.style.display = 'block'; // Always show submit button in show-all-questions mode
    // Only need to handle input selection and form submission
    content.addEventListener('change', handleInputSelection);
    content.addEventListener('input', handleInputSelection);

    // --- Disable submit until all questions are filled ---
    function checkAllQuestionsAnswered() {
      const allQuestions = content.querySelectorAll('.buy-guide__question');
      let allAnswered = true;
      allQuestions.forEach((q) => {
        // Only count visible questions
        if (q.style.display !== 'none') {
          if (!q.classList.contains('answered')) {
            allAnswered = false;
          }
        }
      });
      submitButton.disabled = !allAnswered;
    }
    // Initial check
    checkAllQuestionsAnswered();
    // Re-check on any input change
    content.addEventListener('change', checkAllQuestionsAnswered);
    content.addEventListener('input', checkAllQuestionsAnswered);
    // Do NOT run wizard init
    return;
  }

  // Initialize the wizard (only if not in show all questions mode)
  function initWizard() {
    console.log('[Buy Guide] Initializing wizard');
    // Hide all questions initially
    const questions = content.querySelectorAll('.buy-guide__question');
    const loadingOverlay = document.querySelector('.buy-guide__wizard > .loading-overlay__spinner');
    loadingOverlay.style.display = 'none';
    questions.forEach((question) => {
      question.style.display = 'none';

      // Group radio buttons by question
      const radios = question.querySelectorAll('input[type="radio"]');
      const questionText = question.querySelector('p').textContent.trim();
      const groupName = questionText.toLowerCase().replace(/[^a-z0-9]+/g, '-');

      radios.forEach((radio) => {
        radio.name = groupName;
      });
    });

    // Show the first question
    currentQuestion = questions[0];
    showQuestion(currentQuestion);
  }

  // Function to send data to Zapier webhook
  async function sendToZapier(data) {
    console.log('Sending data to Zapier:', data);
    try {
      const response = await fetch(window.buyGuideSettings.webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      // Since we're using no-cors mode, we can't check response.ok
      // Instead, we'll assume success if we get here
      showMessage(window.buyGuideSettings.successMessage, 'success', null);

      // Scroll to the top of the page after successful submission
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Error sending data to Zapier:', error);
      showMessage(window.buyGuideSettings.errorMessage, 'error', 5000);
    }
  }

  // Get the next question based on current selection
  function getNextQuestion() {
    // Check if current question has a text input
    const textInput = currentQuestion.querySelector('.field__input');
    if (textInput) {
      // For text inputs, just move to the next question in sequence
      const allQuestions = [];
      function collectQuestions(parentElement) {
        const questions = parentElement.querySelectorAll(':scope > .buy-guide__question');
        questions.forEach((q) => {
          allQuestions.push(q);
          // Only look for nested questions in radio responses, not text inputs
          const radioResponses = q.querySelectorAll(':scope > .buy-guide__item-reponse:not(:has(.field__input))');
          radioResponses.forEach((r) => {
            collectQuestions(r);
          });
        });
      }
      collectQuestions(content);

      const currentIndex = allQuestions.indexOf(currentQuestion);
      return allQuestions[currentIndex + 1] || null;
    }

    // Handle radio button questions
    const selectedResponse = currentQuestion.querySelector('input:checked');
    if (!selectedResponse) {
      console.log('No response selected');
      return null;
    }

    // 1. Chercher une sous-question imbriquée dans le wrapper de la réponse sélectionnée
    const responseWrapper = selectedResponse.closest('.buy-guide__item-reponse-wrapper');
    if (responseWrapper) {
      const nestedQuestion = responseWrapper.querySelector('.buy-guide__question:not(.answered)');
      if (nestedQuestion) {
        return nestedQuestion;
      }
    }
    // 2. Si pas de wrapper (ou pas de sous-question dans le wrapper), chercher la sous-question comme frère direct du label réponse
    let nextElement = selectedResponse.closest('label.buy-guide__item-reponse')?.nextElementSibling;
    while (nextElement && !nextElement.classList.contains('buy-guide__question')) {
      nextElement = nextElement.nextElementSibling;
    }
    if (nextElement && nextElement.classList.contains('buy-guide__question') && !nextElement.classList.contains('answered')) {
      return nextElement;
    }
    // 3. Chercher la prochaine question sœur (frère direct de la question courante)
    let nextSibling = currentQuestion.nextElementSibling;
    while (nextSibling && !nextSibling.classList.contains('buy-guide__question')) {
      nextSibling = nextSibling.nextElementSibling;
    }
    if (nextSibling && nextSibling.classList.contains('buy-guide__question') && !nextSibling.classList.contains('answered')) {
      return nextSibling;
    }

    // 3b. Si la question courante est imbriquée (c'est une sous-question),
    // chercher la prochaine question sœur de la question parente
    let parent = currentQuestion.parentElement;
    while (parent && !parent.classList.contains('buy-guide__question')) {
      parent = parent.parentElement;
    }
    if (parent && parent.classList.contains('buy-guide__question')) {
      // Chercher la prochaine question sœur du parent
      let parentNextSibling = parent.nextElementSibling;
      while (parentNextSibling && !parentNextSibling.classList.contains('buy-guide__question')) {
        parentNextSibling = parentNextSibling.nextElementSibling;
      }
      if (parentNextSibling && parentNextSibling.classList.contains('buy-guide__question') && !parentNextSibling.classList.contains('answered')) {
        return parentNextSibling;
      }
    }

    // 4. Sinon, passer à la prochaine question globale non répondue
    const allQuestions = [];
    function collectQuestions(parentElement) {
      const questions = parentElement.querySelectorAll(':scope > .buy-guide__question');
      questions.forEach((q) => {
        allQuestions.push(q);
        // Only look for nested questions in radio responses, not text inputs
        const radioResponses = q.querySelectorAll(':scope > .buy-guide__item-reponse:not(:has(.field__input))');
        radioResponses.forEach((r) => {
          collectQuestions(r);
        });
      });
    }
    collectQuestions(content);
    const currentIndex = allQuestions.indexOf(currentQuestion);
    const nextQuestion = allQuestions.slice(currentIndex + 1).find((q) => !q.classList.contains('answered'));
    return nextQuestion || null;
  }

  // Show a specific question
  function showQuestion(question) {
    if (!question) return;

    // Restaure la réponse sauvegardée si elle existe
    const questionText = question.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
    const answerObj = answersData.questionnaire.find(q => q.question === questionText);
    if (answerObj) {
      if (answerObj.type === 'radio') {
        const radio = question.querySelector(`input[type="radio"][value="${answerObj.answer}"]`);
        if (radio) {
          radio.checked = true;
          radio.closest('.buy-guide__item-reponse').classList.add('selected');
          question.classList.add('answered');
        }
      } else if (answerObj.type === 'checkbox') {
        const checkboxes = question.querySelectorAll(`input[type="checkbox"][value="${answerObj.answer}"]`);
        if (checkboxes) {
          checkboxes.forEach(cb => {
            cb.checked = true;
            cb.closest('.buy-guide__item-reponse').classList.add('selected');
          });
          question.classList.add('answered');
        }
      } else if (answerObj.type === 'text') {
        const textInputs = question.querySelectorAll('.field__input');
        if (typeof answerObj.answer === 'object') {
          const values = Object.values(answerObj.answer);
          values.forEach((val, idx) => {
            if (textInputs[idx]) textInputs[idx].value = val;
          });
        }
        if (Object.values(answerObj.answer).some(v => v && v.trim() !== '')) {
          question.classList.add('answered');
        }
      } else if (answerObj.type === 'size' || answerObj.type === 'checkbox') {
        const checkboxes = question.querySelectorAll('.size-checkbox');
        if (Array.isArray(answerObj.answer)) {
          checkboxes.forEach(cb => {
            if (answerObj.answer.includes(cb.dataset?.value) || answerObj.answer.includes(cb.value)) {
              cb.checked = true;
            } else {
              cb.checked = false;
            }
          });
          if (answerObj.answer.length > 0) {
            question.classList.add('answered');
          }
        }
      }
    }

    // Hide all questions except the new one and its parent if it's nested
    const allQuestions = content.querySelectorAll('.buy-guide__question');
    allQuestions.forEach((q) => {
      if (q === question) {
        // Show the question and all its content
        q.style.display = 'block';
        const questionText = q.querySelector('.buy-guide__question-text');
        if (questionText) questionText.style.display = 'block';
        // Show all direct responses
        q.querySelectorAll(':scope > .buy-guide__item-reponse').forEach((response) => {
          response.style.display = 'block';
        });
      } else if (q.contains(question)) {
        // Keep parent visible but hide its text and direct responses if it's answered
        q.style.display = 'block';
        if (q.classList.contains('answered')) {
          const questionText = q.querySelector('.buy-guide__question-text');
          if (questionText) questionText.style.display = 'none';
          // Hide direct responses but not nested questions
          q.querySelectorAll(':scope > .buy-guide__item-reponse').forEach((response) => {
            response.style.display = 'none';
          });
        }
      } else {
        q.style.display = 'none';
      }
    });

    // Masquer les réponses et le texte de tous les parents de la question courante
    let parent = question.parentElement;
    while (parent) {
      if (parent.classList && parent.classList.contains('buy-guide__question')) {
        // Masquer le texte de la question parente
        const parentText = parent.querySelector('.buy-guide__question-text');
        if (parentText) parentText.style.display = 'none';
        // Masquer uniquement les réponses du parent direct, pas celles de la question courante
        parent.querySelectorAll(':scope > .buy-guide__item-reponse-wrapper, :scope > .buy-guide__item-reponse').forEach((el) => {
          if (!el.contains(question)) {
            el.style.display = 'none';
          }
        });
      }
      parent = parent.parentElement;
    }

    // Si la question courante est imbriquée dans un label réponse sélectionnée, on ajoute une classe pour le masquer via CSS
    const parentLabel = question.closest('.buy-guide__item-reponse-wrapper')?.querySelector('label.buy-guide__item.buy-guide__item-reponse.selected');
    if (parentLabel) {
      parentLabel.classList.add('hide-when-child-question');
    }

    currentQuestion = question;
    
    // Update the main image if the question has a data-image attribute
    const imageUrl = question.getAttribute('data-image');
    const mainImage = document.querySelector('.buy-guide__image-img');
    if (mainImage) {
      if (imageUrl) {
        mainImage.src = imageUrl;
      } else {
        // Optionally, reset to the default section image (initial src)
        const defaultSrc = mainImage.getAttribute('data-default-src');
        if (defaultSrc) {
          mainImage.src = defaultSrc;
        }
      }
    }

    updateNavigationButtons();

    // Only scroll to the question if this is not the initial page load and not in show-all-questions mode
    // if (!showAllQuestionsUser && window._buyGuideHasLoaded) {
    //   setTimeout(() => {
    //     const stickyHeader = document.querySelector('sticky-header');
    //     const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    //     const form = document.getElementById('buy-guide-form');
    //     const formRect = form.getBoundingClientRect();
    //     window.scrollTo({
    //       top: window.pageYOffset + formRect.top - headerHeight - 10,
    //       behavior: 'smooth'
    //     });
    //   }, 50);
    // } else if (!window._buyGuideHasLoaded) {
    //   window._buyGuideHasLoaded = true;
    // }
  }

  // Update navigation buttons state
  function updateNavigationButtons() {
    const textInputs = currentQuestion.querySelectorAll('.field__input');
    const selectedResponse = currentQuestion.querySelector('input[type="radio"]:checked');
    const checkboxes = currentQuestion.querySelectorAll('input[type="checkbox"]:not(#marketing-consent)');
    const checkedCheckboxes = currentQuestion.querySelectorAll('input[type="checkbox"]:not(#marketing-consent):checked');

    // Check if question is required and has text inputs
    const isRequired = currentQuestion.classList.contains('required');
    const hasTextInputs = textInputs.length > 0;
    const hasCheckboxes = checkboxes.length > 0;
    // console.log('hasTextInputs', hasTextInputs);
    // console.log('isRequired', isRequired);
    // console.log('hasCheckboxes', hasCheckboxes);

    // Enable next/submit button based on conditions
    if (hasTextInputs && isRequired) {
      // For required questions with text inputs, all inputs must be filled
      const allFilled = Array.from(textInputs).every((input) => input.value.trim() !== '');
      nextButton.disabled = !allFilled;
      submitButton.disabled = !allFilled;
    } else if (hasTextInputs) {
      // For non-required questions with text inputs, at least one input must be filled
      const anyFilled = Array.from(textInputs).some((input) => input.value.trim() !== '');
      nextButton.disabled = !anyFilled;
      submitButton.disabled = !anyFilled;
    } else if (hasCheckboxes) {
      // For checkbox questions, at least one must be checked
      const anyChecked = checkedCheckboxes.length > 0;
      nextButton.disabled = !anyChecked;
      submitButton.disabled = !anyChecked;
    } else {
      // For radio button questions
      nextButton.disabled = !selectedResponse;
      submitButton.disabled = !selectedResponse;
    }

    // Enable previous button if we have history
    prevButton.disabled = history.length === 0;

    // Check if we have a next question
    let hasNextQuestion = false;
    const allQuestions = [];
    function collectQuestions(parentElement) {
      const questions = parentElement.querySelectorAll(':scope > .buy-guide__question');
      questions.forEach((q) => {
        allQuestions.push(q);
        // Only look for nested questions in radio responses, not text inputs
        const radioResponses = q.querySelectorAll(':scope > .buy-guide__item-reponse:not(:has(.field__input))');
        radioResponses.forEach((r) => {
          collectQuestions(r);
        });
      });
    }
    collectQuestions(content);

    const currentIndex = allQuestions.indexOf(currentQuestion);
    hasNextQuestion = currentIndex < allQuestions.length - 1;

    // Show/hide submit button based on whether there's a next question
    submitButton.style.display = hasNextQuestion ? 'none' : 'block';
    nextButton.style.display = hasNextQuestion ? 'block' : 'none';

    // Ensure marketing consent checkbox is checked before enabling submit
    const marketingConsent = document.getElementById('marketing-consent');
    if (!hasNextQuestion && marketingConsent) {
      submitButton.disabled = submitButton.disabled || !marketingConsent.checked;
    }
  }

  // Update the handleInputSelection function
  function handleInputSelection(event) {
    const input = event.target;
    const question = input.closest('.buy-guide__question');
    const questionText =
      question.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
    const filterParam = question.dataset.filterParameter;

    if (input.type === 'radio') {
      console.log('-----------radio');
      
      // Add answered class to the question
      question.classList.add('answered');

      // Remove selected class from all responses in the current question
      question.querySelectorAll('.buy-guide__item-reponse').forEach((response) => {
        response.classList.remove('selected');
      });

      // Add selected class to current response
      const responseElement = input.closest('.buy-guide__item-reponse');
      responseElement.classList.add('selected');

      // Update answersData
      const answer = input.value;
      const existingIndex = answersData.questionnaire.findIndex((q) => q.question === questionText);

      if (existingIndex !== -1) {
        answersData.questionnaire[existingIndex] = {
          question: questionText,
          answer: answer,
          type: 'radio',
          timestamp: new Date().toISOString(),
        };
      } else {
        answersData.questionnaire.push({
          question: questionText,
          answer: answer,
          type: 'radio',
          timestamp: new Date().toISOString(),
        });
      }

      // Handle filter parameter if present
      if (filterParam) {
        console.log("filterParam", filterParameters[filterParam]);
        console.log("filter answer", answer);
        filterParameters[filterParam] = answer;
        // Build and log the URL parameters
        const urlParams = Object.entries(filterParameters)
          .filter(([key, value]) => isNonEmptyStringOrArray(value))
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&');
        console.log('Current filter URL parameters:', urlParams ? `?${urlParams}` : 'none');
      }
    }
    else if (input.type === 'checkbox' && input.id !== 'marketing-consent') {
      console.log('-----------checkbox');
      // Add answered class to the question
      question.classList.add('answered');

      

      // Add selected class to current response
      const responseElement = input.closest('.buy-guide__item-reponse');
      responseElement.classList.add('selected');

      // Update answersData
      const answer = input.value;
      const existingIndex = answersData.questionnaire.findIndex((q) => q.question === questionText);

      if (existingIndex !== -1) {
        answersData.questionnaire[existingIndex] = {
          question: questionText,
          answer: answer,
          type: 'checkbox',
          timestamp: new Date().toISOString(),
        };
      } else {
        answersData.questionnaire.push({
          question: questionText,
          answer: answer,
          type: 'checkbox',
          timestamp: new Date().toISOString(),
        });
      }

      // Handle filter parameter if present
      if (filterParam) {
        filterParameters[filterParam] = answer;
        // Build and log the URL parameters
        const urlParams = Object.entries(filterParameters)
          .filter(([key, value]) => isNonEmptyStringOrArray(value))
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&');
        console.log('Current filter URL parameters:', urlParams ? `?${urlParams}` : 'none');
      }
    } else if (input.classList.contains('field__input')) {
      // Get all text inputs in this question
      const allTextInputs = question.querySelectorAll('.field__input');
      const allInputValues = {};
      let allFilled = true;

      // Collect all input values and check if they're filled
      allTextInputs.forEach((textInput) => {
        const inputLabel = textInput.getAttribute('placeholder') || textInput.getAttribute('name') || 'Input';
        const inputValue = textInput.value.trim();
        allInputValues[inputLabel] = inputValue;
        if (!inputValue && textInput.required) {
          allFilled = false;
        }
      });

      if (allFilled) {
        question.classList.add('answered');

        // Update answersData
        const existingIndex = answersData.questionnaire.findIndex((q) => q.question === questionText);

        if (existingIndex !== -1) {
          answersData.questionnaire[existingIndex] = {
            question: questionText,
            answer: allInputValues,
            type: 'text',
            timestamp: new Date().toISOString(),
          };
        } else {
          answersData.questionnaire.push({
            question: questionText,
            answer: allInputValues,
            type: 'text',
            timestamp: new Date().toISOString(),
          });
        }

        // Handle filter parameter if present
        if (filterParam) {
          // For text inputs, we'll use the first input's value
          const firstValue = Object.values(allInputValues)[0];
          filterParameters[filterParam] = firstValue;
          // Build and log the URL parameters
          const urlParams = Object.entries(filterParameters)
            .filter(([key, value]) => isNonEmptyStringOrArray(value))
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
          console.log('Current filter URL parameters:', urlParams ? `?${urlParams}` : 'none');
        }
      } else {
        question.classList.remove('answered');
        // Remove from answersData if exists
        answersData.questionnaire = answersData.questionnaire.filter((q) => q.question !== questionText);
        // Remove from filterParameters if exists
        if (filterParam) {
          delete filterParameters[filterParam];
          if (Object.keys(filterParameters).length > 0) {
            const urlParams = Object.entries(filterParameters)
              .filter(([key, value]) => isNonEmptyStringOrArray(value))
              .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
              .join('&');
            console.log('Current filter URL parameters:', urlParams ? `?${urlParams}` : 'none');
          } else {
            console.log('Current filter URL parameters: none');
          }
        }
      }
    }

    // Log the current state of answers
    // Build the flatData object as for Zapier
    const flatData = {};
    answersData.questionnaire.forEach(q => {
      if (q.type === 'radio') {
        const questionEl = Array.from(document.querySelectorAll('.buy-guide__question')).find(el => {
          const text = el.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
          return text === q.question;
        });
        let dataAnswer = q.answer;
        if (questionEl) {
          const input = questionEl.querySelector(`input[type="radio"][value="${q.answer.replace(/"/g, '\"')}"]`);
          if (input && input.hasAttribute('data-answer')) {
            dataAnswer = input.getAttribute('data-answer');
          }
        }
        flatData[q.question] = dataAnswer;
      } else if (q.type === 'size') {
        const questionEl = Array.from(document.querySelectorAll('.buy-guide__question')).find(el => {
          const text = el.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
          return text === q.question;
        });
        let inputValue = '';
        if (questionEl) {
          const input = questionEl.querySelector('.size-input');
          if (input) inputValue = input.value;
        }
        flatData[q.question] = {
          checkboxes: q.answer,
          input: inputValue
        };
      } else {
        flatData[q.question] = q.answer;
      }
    });

    // Add marketing consent value
    const marketingConsent = document.getElementById('marketing-consent');
    flatData['marketing_consent'] = marketingConsent && marketingConsent.checked ? 'yes' : 'no';

    // console.log('Current answers:', flatData);

    updateNavigationButtons();
  }

  // Event listeners
  content.addEventListener('change', handleInputSelection);
  content.addEventListener('input', handleInputSelection);

  nextButton.addEventListener('click', function () {
    // Sauvegarder l'état de la question courante avant d'aller à la suivante
    const state = {};
    // Radios
    const selectedRadio = currentQuestion.querySelector('input[type="radio"]:checked');
    if (selectedRadio) {
      state.type = 'radio';
      state.value = selectedRadio.value;
    }
    // Text inputs
    const textInputs = currentQuestion.querySelectorAll('.field__input');
    if (textInputs.length > 0) {
      state.type = 'text';
      state.values = Array.from(textInputs).map(input => input.value);
    }
    // Checkboxes (tailles)
    const checkedBoxes = currentQuestion.querySelectorAll('input[type="checkbox"]:checked');
    if (checkedBoxes.length > 0) {
      state.type = 'checkbox';
      state.values = Array.from(checkedBoxes).map(cb => cb.value);
    }
    // On stocke aussi le dataset.filterParameter si présent
    if (currentQuestion.dataset.filterParameter) {
      state.filterParameter = currentQuestion.dataset.filterParameter;
    }
    // On stocke aussi la question elle-même
    history.push({ question: currentQuestion, state });
    const next = getNextQuestion();
    if (next) {
      showQuestion(next);
    }
  });

  prevButton.addEventListener('click', function () {
    // Nouvelle gestion du retour arrière
    if (history.length === 0) return;
    const { question: prevQuestion, state } = history.pop();
    // Nettoyer la question courante (désélectionner, vider, etc.)
    // Radios
    const selectedRadio = currentQuestion.querySelector('input[type="radio"]:checked');
    if (selectedRadio) {
      selectedRadio.checked = false;
      selectedRadio.closest('.buy-guide__item-reponse').classList.remove('selected');
    }
    // Text inputs
    const textInputs = currentQuestion.querySelectorAll('.field__input');
    if (textInputs.length > 0) {
      textInputs.forEach(input => { input.value = ''; });
    }
    // Checkboxes
    const checkedBoxes = currentQuestion.querySelectorAll('input[type="checkbox"]:checked');
    if (checkedBoxes.length > 0) {
      checkedBoxes.forEach(cb => { cb.checked = false; });
    }
    // Enlever la classe answered
    currentQuestion.classList.remove('answered');

    // afficher .buy-guide__item-reponse-wrapper de la question précédente
    const parentWrapper = prevQuestion.querySelectorAll('.buy-guide__item-reponse-wrapper');
    if (parentWrapper) {
      parentWrapper.forEach(wrapper => {
        wrapper.style.display = 'block';
      });
    }
    //retirer .hide-when-child-question de la question précédente
    if (parentWrapper) {
      parentWrapper.forEach(wrapper => {
        wrapper.querySelectorAll('.hide-when-child-question').forEach(el => {
          el.classList.remove('hide-when-child-question');
        });
      });
    }

    // Enlever le paramètre de filtre
    const filterParam = currentQuestion.dataset.filterParameter;
    if (filterParam) {
      delete filterParameters[filterParam];
    }
    // Enlever la réponse du answersData
    const questionText = currentQuestion.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
    answersData.questionnaire = answersData.questionnaire.filter((q) => q.question !== questionText);
    // Restaurer l'état de la question précédente
    if (state) {
      if (state.type === 'radio') {
        const radio = prevQuestion.querySelector(`input[type="radio"][value="${state.value}"]`);
        if (radio) {
          radio.checked = true;
          radio.closest('.buy-guide__item-reponse').classList.add('selected');
          prevQuestion.classList.add('answered');
        }
      } else if (state.type === 'text') {
        const textInputs = prevQuestion.querySelectorAll('.field__input');
        state.values.forEach((val, idx) => {
          if (textInputs[idx]) textInputs[idx].value = val;
        });
        // Si au moins un champ rempli, on remet answered
        if (state.values.some(v => v && v.trim() !== '')) {
          prevQuestion.classList.add('answered');
        }
      } else if (state.type === 'checkbox') {
        const checkboxes = prevQuestion.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(cb => {
          if (state.values.includes(cb.value)) {
            cb.checked = true;
          } else {
            cb.checked = false;
          }
        });
        if (state.values.length > 0) {
          prevQuestion.classList.add('answered');
        }
      }
      // Restaurer le paramètre de filtre si présent
      if (state.filterParameter) {
        if (state.type === 'radio') {
          filterParameters[state.filterParameter] = state.value;
        } else if (state.type === 'text') {
          filterParameters[state.filterParameter] = state.values[0];
        } else if (state.type === 'checkbox') {
          filterParameters[state.filterParameter] = state.values;
        }
      }
    }
    // Restaurer la réponse dans answersData (si possible)
    // (On laisse handleInputSelection le faire si besoin)
    showQuestion(prevQuestion);
  });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    try {
      // Transform answersData.questionnaire into a flat object for Zapier
      const flatData = {};
      answersData.questionnaire.forEach(q => {
        // For radio questions, use data-answer if available
        if (q.type === 'radio') {
          // Find the input element for this answer
          const questionEl = Array.from(document.querySelectorAll('.buy-guide__question')).find(el => {
            const text = el.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
            return text === q.question;
          });
          let dataAnswer = q.answer;
          if (questionEl) {
            const input = questionEl.querySelector(`input[type="radio"][value="${q.answer.replace(/"/g, '\"')}"]`);
            if (input && input.hasAttribute('data-answer')) {
              dataAnswer = input.getAttribute('data-answer');
            }
          }
          flatData[q.question] = dataAnswer;
        } else if (q.type === 'size') {
          // For size, send both checked checkboxes and the input value
          const questionEl = Array.from(document.querySelectorAll('.buy-guide__question')).find(el => {
            const text = el.querySelector('.buy-guide__question-text')?.textContent.trim() || 'Question sans texte';
            return text === q.question;
          });
          let inputValue = '';
          if (questionEl) {
            const input = questionEl.querySelector('.size-input');
            if (input) inputValue = input.value;
          }
          flatData[q.question] = {
            checkboxes: q.answer,
            input: inputValue
          };
        } else {
          flatData[q.question] = q.answer;
        }
      });

      // Add marketing consent value
      const marketingConsent = document.getElementById('marketing-consent');
      flatData['marketing_consent'] = marketingConsent && marketingConsent.checked ? 'yes' : 'no';

      // Build the URL with filter parameters
      const baseUrl = window.buyGuideSettings.collectionToFilter;
      const urlParams = Object.entries(filterParameters)
        .filter(([key, value]) => isNonEmptyStringOrArray(value))
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return value
              .filter(v => typeof v === 'string' && v.trim() !== '')
              .map((v) => `${key}=${encodeURIComponent(v)}`)
              .join('&');
          }
          return `${key}=${encodeURIComponent(value)}`;
        })
        .filter(Boolean)
        .join('&');

      // Add the built filter URL to the data sent to Zapier
      const filterUrlForZapier = urlParams ? `https://nooance-paris.com${baseUrl}?${urlParams}` : `https://nooance-paris.com${baseUrl}`;
      flatData['filter_url'] = filterUrlForZapier;

      await sendToZapier(flatData);

      // Redirect to collection page with filters
      const redirectUrl = urlParams ? `${baseUrl}?${urlParams}` : baseUrl;

      
      if (window.buyGuideSettings.redirectToCollection == 'true') {
        window.location.href = redirectUrl;
      } else {
        const productGridContainer = document.getElementById('product-grid');
        const buyGuideForm = document.getElementById('buy-guide-form');
        const loadingOverlay = document.querySelector('.buy-guide .loading-overlay__spinner');
        
        const buyGuideImage = document.querySelector('.buy-guide__image');
        const buyGuide = document.querySelector('.buy-guide');
        

        loadingOverlay.style.display = 'block';
        buyGuideImage.style.display = 'none';
        buyGuide.style.display = 'block';
        // Show and update the debug URL
        

        if (productGridContainer) {

          // Build the URL with the section parameter
          const sectionUrl = `${baseUrl}?sections=main-collection-product-grid&${urlParams}`;

          // Fetch the section content
          fetch(sectionUrl)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              console.log('Received data:', data);
              // Extract just the product grid div from the response
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = data['main-collection-product-grid'];
              const productGrid = tempDiv.querySelector('#product-grid');
              const titleWrapper = tempDiv.querySelector('.title-wrapper');

              if (productGrid) {
                loadingOverlay.style.display = 'none';
                productGridContainer.innerHTML = productGrid.innerHTML;
                buyGuideForm.style.display = 'none';
                
                // Update title wrapper if it exists
                if (titleWrapper) {
                  document.querySelector('.buy-guide__product-grid-message').style.display = 'none';
                  const existingTitleWrapper = document.querySelector('.title-wrapper');
                  if (existingTitleWrapper) {
                    const titleElement = existingTitleWrapper.querySelector('.title');
                    if (titleElement) {
                      titleElement.textContent = window.buyGuideSettings.titleNoResults;
                      
                      // Create and insert description paragraph after the title
                      const descriptionElement = document.createElement('p');
                      descriptionElement.innerHTML = window.buyGuideSettings.titleNoResultsDescription;
                      titleElement.after(descriptionElement);
                    }
                  }
                }
                
                showMessage(window.buyGuideSettings.showProductGridMessage, 'info', null, 'form-message-show-product-grid');
                
              } else {
                showMessage(window.buyGuideSettings.errorMessage, 'error', 5000);
                console.error('Product grid not found in response');
              }
            })
            .catch((error) => {
              console.error('Error fetching product grid:', error);
              showMessage('Une erreur est survenue lors du chargement des produits.', 'error', 5000);
            });
        } else {
          showMessage('Une erreur est survenue lors du chargement des produits.', 'error', 5000);
        }
      }
    } catch (error) {
      console.error('Error in form submission:', error);
      showMessage(
        'Une erreur est survenue lors de la soumission de votre sélection. Veuillez réessayer.',
        'error',
        5000
      );
    }
  });

  // Only call initWizard if not in show all questions mode
  initWizard();
});

// Helper function to check for non-empty string or array of non-empty strings
function isNonEmptyStringOrArray(value) {
  if (Array.isArray(value)) {
    return value.length > 0 && value.some(v => typeof v === 'string' && v.trim() !== '');
  }
  return typeof value === 'string' && value.trim() !== '';
}